import request from '@/router/axios';
import website from "@/config/website";

export const loginByUsername = (tenantId, username, password, type, key, code,refresh_token) => request({
  url: '/api/blade-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': tenantId,
    'Captcha-Key': key,
    'Captcha-Code': code,
  },
  params: {
    tenantId,
    refresh_token,
    username,
    password,
    loginType:'1',
    grant_type: (website.captchaMode ? "captcha" : "password"),
    scope: "all",
    type
  }
});

export const loginBySocial = (tenantId, source, code, state) => request({
  url: '/api/blade-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': tenantId
  },
  params: {
    tenantId,
    source,
    loginType:'1',
    code,
    state,
    grant_type: "social",
    scope: "all",
  }
})

export const refreshToken = (refresh_token, tenantId) => request({
  url: '/api/blade-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': tenantId
  },
  params: {
    tenantId,
    loginType:'1',
    refresh_token,
    grant_type: "refresh_token",
    scope: "all",
  }
});

export const registerGuest = (form, oauthId) => request({
  url: '/api/blade-user/register-guest',
  method: 'post',
  params: {
    tenantId: form.tenantId,
    name: form.name,
    account: form.account,
    password: form.password,
    oauthId
  }
});

export const getButtons = () => request({
  url: '/api/blade-system/menu/buttons',
  method: 'get'
});

export const getCaptcha = () => request({
  url: '/api/blade-auth/oauth/captcha',
  method: 'get',
  params: {
    // tenantId: '123369'
  }
});

export const logout = () => request({
  url: '/api/blade-auth/oauth/logout',
  method: 'get'
});
export const logoutDev = (list) => request({
  url: '/api/blade-auth/oauth/logout/dev',
  method: 'post',
  data: list
});

export const getUserInfo = () => request({
  url: '/api/blade-auth/oauth/user-info',
  method: 'get'
});

export const sendLogs = (list) => request({
  url: '/api/blade-auth/oauth/logout',
  method: 'post',
  data: list
});

export const clearCache = () => request({
  url: '/api/blade-auth/oauth/clear-cache',
  method: 'get'
});


// 用户扩展信息查询
export const platformDetail = (id) => {
  return request({
    url: `/api/blade-user/platform-detail`,
    method: 'GET',
    params: {
      id: id
    }
  })
}
// 发送短信
// export const sendValidate = (params) => {

//   return request({
//     url: '/api/blade-resource/sms/endpoint/send-validate',
//     method: 'post',
//     headers: {
//       'Content-Type': 'application/x-www-form-urlencoded',
//       'Tenant-Id': '123369'
//     },
//     params
//   })
// }
export const sendValidate = (params) => request({
  url: '/api/blade-resource/sms/endpoint/send-validate',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Tenant-Id': '123369'
  },
  params
});
// 校验短信
export const validateMessage = (params) => request({
  url: '/api/blade-resource/sms/endpoint/validate-message',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'tenantId': '123369'
  },
  params
});

// 按手机号码修改密码
export const updatePassword = (params) => request({
  url: '/api/blade-user/phone/update-password',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    
  },
  params
});


